var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerceivedThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9F2;}\r\n\t.st1{fill:#9ED4FF;}\r\n\t.st2{fill:#00FFFF;}\r\n\t.st3{fill:#00FF00;}\r\n\t.st4{fill:#FFFF00;}\r\n\t.st5{fill:#FFAA00;}\r\n\t.st6{fill:#FF0000;}\r\n\t.st7{fill:#646464;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st1",
    d: "M256.1,2c140.3,0,254,113.7,254,254c0,140.2-113.6,253.9-254,253.9C115.8,510,2,396.3,2,256.1 C2,115.8,115.8,2,256.1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.9,314.9c10.4,0,18.4-2.8,23.8-8.3c5.5-5.5,8.2-12.3,8.2-20.2c0-9.6-2.8-16.6-8.6-21.2 c-5.7-4.6-14.7-6.8-27-6.8h-18.1V241l30.5-41.6l14.4-11.4l-19.9,2.3h-42.4v-27.7h96.3v17.9l-35.6,47.6l-11.1,6.8v1.3l10.6-1.5 c5.9,0.5,11.5,1.9,16.8,4c5.3,2.2,9.9,5.4,13.9,9.4c4,4.1,7.1,9.2,9.5,15.3c2.4,6.1,3.5,13,3.5,20.9c0,9.9-1.6,18.5-4.9,25.7 c-3.3,7.2-7.8,13.3-13.6,18.1c-5.8,4.9-12.6,8.5-20.3,10.8c-7.7,2.4-16,3.5-25,3.5c-7.4,0-15.1-0.7-23-2 c-7.9-1.3-14.3-3.3-19.2-5.8l8.8-27.2c4.4,2.2,9.2,4,14.5,5.3C231.4,314.2,237.4,314.9,243.9,314.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerceivedThree);
export default __webpack_public_path__ + "static/media/PerceivedThree.cab52aae11cf44af7d649e5073b6c9f6.svg";
export { ForwardRef as ReactComponent };